import React, { Component } from 'react';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import Agenda from '~/containers/agenda/agenda';

export default class AgendaPage extends Component {
  render() {
    return (
      <Page>
        <TitleBar title="Agenda" />
        <Agenda />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/agenda/agenda.jsx